import { environment } from '@formrails/environments';

/**
 * Environments a template can be promoted into, in the order it travels:
 * CI and local promote to sandbox, sandbox promotes to production.
 */
export type PromotionTarget = 'Sandbox' | 'Production';

/**
 * Where a promotion from the environment this build is serving lands, or null
 * in production, where there is nowhere further to go.
 *
 * Part of the promotion feature: the environment file is the single place the
 * chain is described, so adding an environment means editing that file only.
 */
export const PROMOTION_TARGET =
  (environment.promotionTarget ?? null) as PromotionTarget | null;

/**
 * The target in running prose, e.g. "promoted to sandbox". Falls back to the
 * environment recorded on the promotion itself, which is what actually
 * happened, and is what to trust once a promotion exists.
 */
export function promotionTargetLabel(recorded?: string | null): string {
  return (recorded ?? PROMOTION_TARGET ?? 'production').toLowerCase();
}
